import { ArrowBottomRightBoldOutlineIcon } from './ArrowBottomRightBoldOutlineIcon';

/**
 * author: Michael Irigoyen
 * id ABD34714-B566-4EDF-B876-93BFB6D254CB
 * name arrow-bottom-right-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-bottom-right-bold-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowDownRightBoldOutlineIcon = ArrowBottomRightBoldOutlineIcon;
export default ArrowDownRightBoldOutlineIcon